export class FreeShiftPlanningGroup {
  public constructor (
    public shiftId: number | undefined,
    public planningGroupId: number | undefined,
    public numberOfEmployees: number,
    public comment: string,
    public departments: number | undefined,
    public planningGroup: number | undefined,
    public departmentsDesignation: string,
    public planningGroupName: string,
    public offset: string
  ) {}
}
